import { Autocomplete, TextField } from "@mui/material";
import * as React from "react";

export function CustomAutocompleteAlert({ id, data, title, onChange, value, disabled }) {
  return (
    <Autocomplete
      disablePortal
      disabled={disabled}
      id={id}
      options={data}
      onChange={onChange}
      value={value}
      sx={{
        width: "auto",
        margin: "5px 0px",
        "& .MuiInputBase-root": {
          fontSize: "14px",
          "@media (max-width: 960px) and (min-width: 688px)": {
            fontSize: "12px",
          },
          "@media (max-width: 687px)": {
            fontSize: "10px",
          },
        },
        "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
          fontSize: "13px",
          "@media (max-width: 960px) and (min-width: 688px)": {
            fontSize: "12px",
          },
          "@media (max-width: 687px)": {
            fontSize: "10px",
          },
        },
        "& .css-19qh8xo-MuiInputBase-input-MuiOutlinedInput-input": {
          height: "12px",
        },
        "& .css-1pysi21-MuiFormLabel-root-MuiInputLabel-root": {
          top: "-4px",
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={title}
          sx={{
            fontSize: "20px",
            "& .MuiInputLabel-root": {
              fontSize: "14px",
              color: "red",
              fontStyle: "italic",
              "@media (max-width: 960px) and (min-width: 688px)": {
                fontSize: "12px",
              },
              "@media (max-width: 687px)": {
                fontSize: "10px",
              },
            },
            "& label.Mui-focused": {
              color: "#c4960c",
            },
            // focused color for input with variant='standard'
            "& .MuiInput-underline:after": {
              borderBottomColor: "#c4960c",
            },
            // focused color for input with variant='filled'
            "& .MuiFilledInput-underline:after": {
              borderBottomColor: "#c4960c",
            },
            // focused color for input with variant='outlined'
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: "#c4960c",
              },
            },
          }}
        />
      )}
      size="small"
    />
  );
}

export function CustomAutocomplete({ id, data, title, value, handleChange, className, name, disabled, placeholder }) {
  return (
    <Autocomplete componentName={name} className={className} value={value} disablePortal onChange={handleChange} fullWidth={true} id={id} options={data} disabled={disabled}
      getOptionLabel={(option) => (option === undefined ? undefined : option)}
      sx={{
        width: "auto",
        "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
          fontSize: "13px",
        },
        "& .MuiInputBase-root": {
          fontSize: "14px",
          "@media (max-width: 960px) and (min-width: 688px)": {
            fontSize: "12px",
          },
          "@media (max-width: 687px)": {
            fontSize: "10px",
          },
        },
        "& .css-19qh8xo-MuiInputBase-input-MuiOutlinedInput-input": {
          height: "12px",
        },
        "& .css-1pysi21-MuiFormLabel-root-MuiInputLabel-root": {
          top: "-4px",
          "@media (max-width: 960px) and (min-width: 688px)": {
            top: "-2px",
          },
          "@media (max-width: 687px)": {
            top: "0px",
          },
        }
      }}
      renderInput={(params) => (
        <TextField placeholder={placeholder}
          {...params}
          label={title}
          sx={{
            fontSize: "25px",
            "& label.Mui-focused": {
              color: "#c4960c",
            },
            // focused color for input with variant='standard'
            "& .MuiInput-underline:after": {
              borderBottomColor: "#c4960c",
            },
            // focused color for input with variant='filled'
            "& .MuiFilledInput-underline:after": {
              borderBottomColor: "#c4960c",
            },
            // focused color for input with variant='outlined'
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: "#c4960c",
              },
              "& .MuiAutocomplete-input": {
                fontSize: "13px",
                "@media (max-width: 960px) and (min-width: 688px)": {
                  fontSize: "11px",
                },
                "@media (max-width: 687px)": {
                  fontSize: "10px",
                  height: "10px",
                },
              },
            },
            "& .MuiInputLabel-root": {
              fontSize: "14px",
              "@media (max-width: 960px) and (min-width: 688px)": {
                fontSize: "12px",
              },
              "@media (max-width: 687px)": {
                fontSize: "10px",
                height: "10px",
              },
            },
          }}
        />
      )}
      size="small"
    />
  );
}

export function CustomMultipleAutocomplete({ id, data, title, value, handleChange, className, name, disabled, placeholder }) {
  return (
    <Autocomplete componentName={name} className={className} value={value} disablePortal onChange={handleChange} fullWidth={true} id={id} options={data} disabled={disabled}
      getOptionLabel={(option) => (option === undefined ? undefined : option)} multiple filterSelectedOptions
      sx={{
        width: "auto",
        // margin: "6px 0px",
        "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
          fontSize: "13px",
          "@media (max-width: 960px) and (min-width: 688px)": {
            fontSize: "12px",
          },
          "@media (max-width: 687px)": {
            fontSize: "10px",
          },
        },
        "& .MuiInputBase-root": {
          fontSize: "14px",
          "@media (max-width: 960px) and (min-width: 688px)": {
            fontSize: "12px",
          },
          "@media (max-width: 687px)": {
            fontSize: "10px",
          },
        },
        "& .css-19qh8xo-MuiInputBase-input-MuiOutlinedInput-input": {
          height: "12px",
        },
        "& .css-1pysi21-MuiFormLabel-root-MuiInputLabel-root": {
          top: "-4px"
        }
      }}
      renderInput={(params) => (
        <TextField placeholder={placeholder}
          {...params} variant="outlined"
          label={title}
          sx={{
            fontSize: "25px",
            "& label.Mui-focused": {
              color: "#c4960c",
            },
            // focused color for input with variant='standard'
            "& .MuiInput-underline:after": {
              borderBottomColor: "#c4960c",
            },
            // focused color for input with variant='filled'
            "& .MuiFilledInput-underline:after": {
              borderBottomColor: "#c4960c",
            },
            // focused color for input with variant='outlined'
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: "#c4960c",
              },
              "& .MuiAutocomplete-input": {
                fontSize: "13px",
                "@media (max-width: 960px) and (min-width: 688px)": {
                  fontSize: "11px",
                },
                "@media (max-width: 687px)": {
                  fontSize: "10px"
                },
              },
            },
            "& .MuiInputLabel-root": {
              fontSize: "14px",
              "@media (max-width: 960px) and (min-width: 688px)": {
                fontSize: "12px",
              },
              "@media (max-width: 687px)": {
                fontSize: "10px",
              },
            },
            "& .css-1a9jshs-MuiButtonBase-root-MuiChip-root": {
              fontSize: "13px",
              backgroundColor: "#0000001a",
              "@media (max-width: 960px) and (min-width: 688px)": {
                fontSize: "12px",
              },
              "@media (max-width: 687px)": {
                fontSize: "10px",
              },
            },
            "& .css-1a9jshs-MuiButtonBase-root-MuiChip-root.Mui-disabled": {
              opacity: 1,
            }
          }}
        />
      )}
      size="small"
    />
  );
}

export function CustomAutocompleteDisabled({
  id,
  data,
  title,
  styled,
  values,
}) {
  return (
    <Autocomplete
      value={values}
      disablePortal
      disabled
      id={id}
      options={data}
      sx={styled}
      renderInput={(params) => (
        <TextField
          {...params}
          label={title}
          sx={{
            fontSize: "25px",
            "& label.Mui-focused": {
              color: "#c4960c",
            },
            // focused color for input with variant='standard'
            "& .MuiInput-underline:after": {
              borderBottomColor: "#c4960c",
            },
            // focused color for input with variant='filled'
            "& .MuiFilledInput-underline:after": {
              borderBottomColor: "#c4960c",
            },
            // focused color for input with variant='outlined'
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: "#c4960c",
              },
              "& .MuiAutocomplete-input": {
                fontSize: "13px",
                "@media (max-width: 960px) and (min-width: 688px)": {
                  fontSize: "11px",
                },
                "@media (max-width: 687px)": {
                  fontSize: "10px",
                },
              },
            },
            "& .MuiInputLabel-root": {
              fontSize: "13px",

              "@media (max-width: 960px) and (min-width: 688px)": {
                fontSize: "11px",
              },
              "@media (max-width: 687px)": {
                fontSize: "10px",
              },
            },
          }}
        />
      )}
      size="small"
    />
  );
}
